import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { deputyActions, deputySelectors } from '../duck';

import DeputyEdit from './DeputyEdit';
import ComponentWithError from '../../shared/HOCs/componentWithError';
import WithLoader from '../../shared/HOCs/withLoader';
import { townActions, townSelectors } from '../../towns/duck';
import { areaActions, areaSelectors } from '../../areas/duck';
import { districtActions, districtSelectors } from '../../districts/duck';

const mapStateToProps = state => ({
  isFetching: deputySelectors.isFetchingDeputy(state),
  errors: deputySelectors.deputyErrors(state),
  deputy: deputySelectors.deputy(state),
  districts: districtSelectors.districts(state),
  towns: townSelectors.towns(state),
  areas: areaSelectors.areas(state),
});

const mapDispatchToProps = {
  fetch: deputyActions.fetchDeputy,
  editDeputy: deputyActions.editDeputy,
  removeDeputy: deputyActions.removeDeputy,
  removeDeputyPhoto: deputyActions.removeDeputyPhoto,
  fetchDistricts: districtActions.fetchDistricts,
  fetchTowns: townActions.fetchTowns,
  fetchAreas: areaActions.fetchAreas,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WithLoader(ComponentWithError(DeputyEdit)))
);
